import React from 'react';
import { ArrowRight, Shield, TrendingUp, Users } from 'lucide-react';

const Hero = () => {
    const scrollToSection = (sectionId: string) => {
        const element = document.getElementById(sectionId);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <section id="home" className="pt-16 bg-gradient-to-br from-blue-50 via-white to-blue-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
                    {/* Content */}
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                                Your Path to
                                <span className="text-blue-700 block">Financial Freedom</span>
                            </h1>
                            <p className="text-xl text-gray-600 leading-relaxed">
                                At Saisamriddhi, we provide comprehensive financial solutions tailored to your unique needs.
                                From investment planning to wealth management, we're your trusted partner in building a secure financial future.
                            </p>
                        </div>

                        {/* CTA Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4">
                            <button
                                onClick={() => scrollToSection('services')}
                                className="bg-blue-700 text-white px-8 py-4 rounded-lg font-semibold hover:bg-blue-800 transition-all duration-200 flex items-center justify-center group"
                            >
                                Explore Services
                                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform duration-200" />
                            </button>
                            <button
                                onClick={() => scrollToSection('contact')}
                                className="border-2 border-blue-700 text-blue-700 px-8 py-4 rounded-lg font-semibold hover:bg-blue-700 hover:text-white transition-all duration-200"
                            >
                                Get Started
                            </button>
                        </div>

                        {/* Stats */}
                        <div className="grid grid-cols-3 gap-8 pt-8">
                            <div className="text-center">
                                <div className="text-3xl font-bold text-blue-700">500+</div>
                                <div className="text-gray-600">Happy Clients</div>
                            </div>
                            <div className="text-center">
                                <div className="text-3xl font-bold text-blue-700">₹50Cr+</div>
                                <div className="text-gray-600">Assets Managed</div>
                            </div>
                            <div className="text-center">
                                <div className="text-3xl font-bold text-blue-700">15+</div>
                                <div className="text-gray-600">Years Experience</div>
                            </div>
                        </div>
                    </div>

                    {/* Image */}
                    <div className="relative">
                        <div className="relative z-10">
                            <img
                                src="https://images.pexels.com/photos/3760067/pexels-photo-3760067.jpeg?auto=compress&cs=tinysrgb&w=800"
                                alt="Financial Planning"
                                className="w-full h-96 lg:h-[500px] object-cover rounded-2xl shadow-2xl"
                            />
                        </div>
                        {/* Floating Cards */}
                        <div className="absolute -top-6 -left-6 bg-white p-4 rounded-xl shadow-lg border border-gray-100 z-20">
                            <div className="flex items-center space-x-3">
                                <div className="bg-green-100 p-2 rounded-lg">
                                    <TrendingUp className="h-6 w-6 text-green-600" />
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-900">+12.5%</div>
                                    <div className="text-sm text-gray-600">Portfolio Growth</div>
                                </div>
                            </div>
                        </div>
                        <div className="absolute -bottom-6 -right-6 bg-white p-4 rounded-xl shadow-lg border border-gray-100 z-20">
                            <div className="flex items-center space-x-3">
                                <div className="bg-blue-100 p-2 rounded-lg">
                                    <Shield className="h-6 w-6 text-blue-600" />
                                </div>
                                <div>
                                    <div className="font-semibold text-gray-900">Secured</div>
                                    <div className="text-sm text-gray-600">Investments</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;